// extracted by mini-css-extract-plugin
export default {"changeLink":"eW-z","disabled":"fW-z","inline":"gW-z"};